<template>
    <div role="tabpanel" class="tab-pane" :class="{active: active}" :id="id">
        <slot></slot>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        props: {
            header: {
                type: String
            },
            disabled: {
                type: Boolean,
                'default': false
            },
            onSelected: {
                type: Function,
                'default': () => {}
            }
        },
        data() {
            return {
                id: '',
                _active: false
            };
        },
        computed: {
            active: {
                get() {
                    return this.$data._active;
                },
                set(val) {
                    this.$data._active = val;

                    if (val) {
                        this.onSelected();
                    }
                }
            }
        },
        compiled() {
            this.$parent.registerTab(this);
        }
    };
</script>



// WEBPACK FOOTER //
// Tab.vue?d4207dcc